import { downloadExcel, ColumnConfig } from '../../../utils/excelFileHelper';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { SCUIButton } from '../../atoms';
import { useTranslation } from 'react-i18next';
import { CSSProperties, useState } from 'react';
import { CircularProgress } from '@mui/material';

interface SCUIDownloadButtonProps {
    position?: 'left' | 'center' | 'right';
    excelData?: {
        excelDownloadData: any[];
        excelDownloadFolderName?: string;
        hiddenExcelColumn?: string[];
        excelDownloadButtonText?: string;
        logo?: string;
        columnConfig?: ColumnConfig;
    };
    onclick?: () => Promise<any[]> | any;
    style?: CSSProperties;
    containerStyle?: CSSProperties;
}

function SCUIDownloadButton({ position = 'left', excelData, onclick, style, containerStyle }: SCUIDownloadButtonProps) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const getAlignment = () => {
        switch (position) {
            case 'left':
                return 'flex-start';
            case 'right':
                return 'flex-end';
            case 'center':
                return 'center';
            default:
                return 'flex-start';
        }
    };

    const handleDownload = async () => {
        if (!onclick && !excelData?.excelDownloadData) {
            return;
        }

        setIsLoading(true);

        try {
            if (onclick) {
                const result = onclick();

                if (result instanceof Promise) {
                    const data = await result;

                    if (data && data.length > 0) {
                        downloadExcel({
                            excelDownloadData: data,
                            excelDownloadFolderName: excelData?.excelDownloadFolderName,
                            hiddenExcelColumn: excelData?.hiddenExcelColumn,
                            logo: excelData?.logo,
                            columnConfig: excelData?.columnConfig,
                        });
                    }
                } else if (result && Array.isArray(result) && result.length > 0) {
                    downloadExcel({
                        excelDownloadData: result,
                        excelDownloadFolderName: excelData?.excelDownloadFolderName,
                        hiddenExcelColumn: excelData?.hiddenExcelColumn,
                        logo: excelData?.logo,
                        columnConfig: excelData?.columnConfig,
                    });
                }
            } else if (excelData?.excelDownloadData) {
                downloadExcel(excelData);
            }
        } catch (error) {
            console.error('Error getting data from onclick function:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div
            style={
                containerStyle || {
                    width: '100%',
                    display: 'flex',
                    justifyContent: getAlignment(),
                }
            }
        >
            <SCUIButton
                type={'primary'}
                sizeType={'fixed'}
                size={'s'}
                text={excelData?.excelDownloadButtonText || t('general.exportToExcel')}
                showStartIcon
                startIcon={
                    isLoading ? (
                        <CircularProgress size={20} style={{ color: 'white' }} />
                    ) : (
                        <FileDownloadIcon style={{ color: 'white' }} />
                    )
                }
                onClick={() => handleDownload()}
                disabled={isLoading}
                style={style}
            />
        </div>
    );
}

export default SCUIDownloadButton;
